import { ITabPanelConfig } from '../../../../../@core/components/ui/tabs-panels/tabs-panels.component';
import { GeoTechnicalSummaryComponent } from '../../geo-technical-analysis-report/tabs/geo-technical-summary/geo-technical-summary.component';
import { GeoTechnicalDashboardComponent } from '../../geo-technical-analysis-report/tabs/geo-technical-dashboard/geo-technical-dashboard.component';
import { GeoTechnicalAiDashboardTabComponent } from '../../geo-technical-analysis-report/tabs/geo-technical-ai-dashboard-tab/geo-technical-ai-dashboard-tab.component';
import { GeoTechnicalAnalysisSummaryTabComponent } from './analysis-summary-tab/analysis-summary-tab.component';
import { GeoTechnicalAnalysisCommentsTabComponent } from './comments-tab/comments-tab.component';
import { GeoTechnicalReportsTabComponent } from './reports-tab/reports-tab.component';
import { GeoTechnicalExportsTabComponent } from './exports-tab/exports-tab.component';

export interface GeoTechnicalAnalysisTabConfig extends ITabPanelConfig {
    tour?: {
        stepId: string;
    };
}

/**
 * Right panel tabs: Reports (PDF viewer), Exports (placeholder), Comments.
 * The former "Ask Bob" tab has been replaced by the global floating chat bubble
 * registered from GeoTechnicalAnalysisReportComponent.
 */
export function createTabsConfig(
    _currentRole: string,
    _CONTRACT_USER_ROLE: any,
): GeoTechnicalAnalysisTabConfig[] {
    return [
        {
            value: 'reports',
            label: 'Reports',
            icon: 'file-text',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalReportsTabComponent,
        },
        {
            value: 'exports',
            label: 'Exports',
            icon: 'file-down',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalExportsTabComponent,
        },
        {
            value: 'comments',
            label: 'Comments',
            icon: 'messages-square',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalAnalysisCommentsTabComponent,
            tour: {
                stepId: 'step19',
            },
        },
    ];
}

/**
 * Left panel (dashboard) tabs: Report Summary, Overview, Analysis Summary, AI Dashboard.
 * The order and labels match the Figma design.
 */
export function createGeoTechnicalAnalysisTabsConfig(): GeoTechnicalAnalysisTabConfig[] {
    return [
        {
            value: 'geotechnicalsummary',
            label: 'Report Summary',
            icon: 'list',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalSummaryComponent,
        },
        {
            value: 'geotechnicaldashboard',
            label: 'Overview',
            icon: 'layout-dashboard',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalDashboardComponent,
        },
        {
            value: 'geotechnicalanalysissummary',
            label: 'Analysis Summary',
            icon: 'file-text',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalAnalysisSummaryTabComponent,
        },
        {
            value: 'geotechnicalaidashboard',
            label: 'AI Dashboard',
            icon: 'sparkles',
            iconSource: 'lucide',
            iconSize: 'sm',
            visible: true,
            component: GeoTechnicalAiDashboardTabComponent,
            /** Always rendered with a gradient fill; handled in tabs-panels.component.scss */
            customClass: ' geo-tab-ai-dashboard',
        },
    ];
}
